var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.752 23.994L6.879 14.121C6.31659 13.5584 6.00064 12.7955 6.00064 12C6.00064 11.2045 6.31659 10.4416 6.879 9.87902L16.746 0.0120239L18.16 1.42602L8.293 11.293C8.10553 11.4806 8.00021 11.7349 8.00021 12C8.00021 12.2652 8.10553 12.5195 8.293 12.707L18.166 22.58L16.752 23.994Z",
    fill: "#000029"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.ec5428b3de0fcd3ff1cc0c8e287365e1.svg";
export { ForwardRef as ReactComponent };